import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "card-header-row"
};
const _hoisted_2 = {
  class: "header-left"
};
const _hoisted_3 = {
  class: "header-title-row"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "card-status"
};
const _hoisted_6 = ["aria-label", "aria-expanded"];
const _hoisted_7 = {
  class: "task-panel analysis-grid"
};
const _hoisted_8 = {
  key: 0,
  class: "empty-tip"
};
const _hoisted_9 = {
  class: "task-icon",
  "aria-hidden": "true"
};
const _hoisted_10 = ["href"];
const _hoisted_11 = {
  class: "row-body"
};
const _hoisted_12 = ["title"];
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  class: "score"
};
const _hoisted_15 = {
  key: 1,
  class: "tile-hint"
};
const _hoisted_16 = ["aria-label"];
const _hoisted_17 = {
  key: 3,
  class: "mini-progress",
  "aria-label": "检测中"
};
const _hoisted_18 = {
  key: 4,
  class: "failure-inline"
};
const _hoisted_19 = ["title"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 0,
  class: "status-icon",
  "aria-hidden": "true"
};
const _hoisted_22 = ["href"];
import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { setFoldFunc, removeFoldFunc } from '@views/main/states/fold.state';
import initIncrementalUpdate from '../report-items/mixins/incrementalUpdate.mixin';
import sparklesIcon from './geo-analysis-sparkles.png';
const title = '多维GEO信息检查';
const subtitle = '从多个维度分析品牌与内容表现';
export default /*@__PURE__*/_defineComponent({
  __name: 'GeoAnalysis',
  props: {
    item: {},
    content: {}
  },
  emits: ["retry"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const mainStore = useMainStore();
    const {
      incrementalMessageList
    } = storeToRefs(mainStore);
    const info = ref({});
    const subNodes = ref([]);
    const isFold = ref(false);
    const EXPECTED_SUB_CODES = [60301, 60302, 60303, 60304, 60305, 60306];
    let nextLoaded = false;
    const TASK_ICON_IDS = ['#geo-ana-icon-brain', '#geo-ana-icon-shield', '#geo-ana-icon-authority', '#geo-ana-icon-user', '#geo-ana-icon-doc', '#geo-ana-icon-chart'];
    const getNodeIconId = index => TASK_ICON_IDS[index % TASK_ICON_IDS.length];
    const doneCount = computed(() => subNodes.value.filter(n => n.status === 3).length);
    const total = computed(() => subNodes.value.length);
    const isAllDone = computed(() => total.value > 0 && doneCount.value === total.value);
    const titleSuffix = computed(() => {
      if (info.value.executeStatus === 3) return `(已完成 ${total.value}/${total.value})`;
      if (info.value.executeStatus === 2) return '(失败)';
      if (total.value === 0) return '';
      if (isAllDone.value) return `(已完成 ${doneCount.value}/${total.value})`;
      return `(进行中 ${doneCount.value}/${total.value})`;
    });
    const STATUS_PILL = {
      0: {
        class: 'wait-pill',
        text: '待开始',
        iconId: ''
      },
      1: {
        class: 'run-pill',
        text: '检测中',
        iconId: '#geo-ana-icon-status-loading'
      },
      2: {
        class: 'fail-pill',
        text: '检测失败',
        iconId: '#geo-ana-icon-status-error'
      },
      3: {
        class: 'done-pill',
        text: '检测完成',
        iconId: '#geo-ana-icon-status-success'
      }
    };
    const STATUS_ROW_CLASS = {
      0: 'is-wait',
      1: 'is-running',
      2: 'is-failed',
      3: 'is-success'
    };
    const getScoreSummary = node => {
      const data = node.data || {};
      if (data.geo_score !== undefined) return {
        label: '综合评分',
        value: data.geo_score
      };
      if (data.overall_score !== undefined) return {
        label: '综合评分',
        value: data.overall_score
      };
      if (data.technical_score !== undefined) return {
        label: '技术评分',
        value: data.technical_score
      };
      if (data.eeat_score !== undefined) return {
        label: 'E-E-A-T 评分',
        value: data.eeat_score
      };
      if (data.authority_score !== undefined) return {
        label: '权威性评分',
        value: data.authority_score
      };
      if (data.experience_score !== undefined) return {
        label: '体验评分',
        value: data.experience_score
      };
      if (data.competition_score !== undefined) return {
        label: '竞争力评分',
        value: data.competition_score
      };
      if (data.schema_score !== undefined) return {
        label: '结构化评分',
        value: data.schema_score
      };
      if (data.average_score !== undefined) return {
        label: '平均分',
        value: data.average_score
      };
      if (data.crawler_access_score !== undefined) return {
        label: '爬虫访问评分',
        value: data.crawler_access_score
      };
      if (data.grade) return {
        label: '等级',
        value: data.grade
      };
      if (data.level) return {
        label: '等级',
        value: data.level
      };
      return null;
    };
    const getProgress = node => {
      const data = node.data || {};
      if (typeof data.progress === 'number') return Math.min(100, Math.max(0, data.progress));
      if (typeof data.percent === 'number') return Math.min(100, Math.max(0, data.percent));
      return null;
    };
    const toggleFold = val => {
      isFold.value = typeof val === 'boolean' ? val : !isFold.value;
    };
    const handleRetry = node => {
      emits('retry', node);
    };
    const tryLoadNext = () => {
      if (nextLoaded || !props.item?.openAnimate) return;
      const allArrived = EXPECTED_SUB_CODES.every(code => subNodes.value.some(n => n.code === code));
      const noneRunning = subNodes.value.every(n => n.status !== 1);
      const stageFinished = info.value.executeStatus === 3 || info.value.executeStatus === 2;
      if (stageFinished || allArrived && noneRunning && subNodes.value.length > 0) {
        nextLoaded = true;
        mainStore.loadNextMsg(props.item);
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      if (props.item.id === message.id) {
        const {
          incrementalData,
          messageType,
          openAnimate
        } = message;
        const nodeName = message.nodeName || `节点${messageType}`;
        isFold.value = false;
        if (incrementalData.error) {
          const existing = subNodes.value.find(n => n.code === messageType);
          if (existing) {
            existing.status = 2;
            existing.data = {
              error: incrementalData.error,
              ...existing.data
            };
          } else {
            subNodes.value.push({
              code: messageType,
              nodeName,
              status: 2,
              data: {
                error: incrementalData.error
              }
            });
          }
        } else {
          const existing = subNodes.value.find(n => n.code === messageType);
          const newStatus = openAnimate === 1 ? 1 : 3;
          if (existing) {
            existing.status = newStatus;
            existing.data = incrementalData;
          } else {
            subNodes.value.push({
              code: messageType,
              nodeName,
              status: newStatus,
              data: incrementalData
            });
          }
        }
        tryLoadNext();
      }
    });
    const initFromMessageContent = () => {
      const {
        messageContent
      } = info.value;
      if (!messageContent) return;
      Object.entries(messageContent).forEach(([code, nodeData]) => {
        const existing = subNodes.value.find(n => n.code === Number(code));
        if (existing) {
          existing.status = nodeData.status;
          existing.data = nodeData;
        } else {
          subNodes.value.push({
            code: Number(code),
            nodeName: nodeData.nodeName || `节点${code}`,
            status: nodeData.status,
            data: nodeData
          });
        }
      });
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
      if (props.item.id) removeFoldFunc(props.item.id);
    });
    watch(() => props.content, val => {
      if (!val) return;
      info.value = val;
      initFromMessageContent();
      tryLoadNext();
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
        setFoldFunc(props.item.id, toggleFold);
      }
      try {
        info.value = props.content || {};
        initFromMessageContent();
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
        tryLoadNext();
      } catch (e) {
        info.value = {};
      }
    });
    __expose({
      isFold,
      setIsFold: val => {
        isFold.value = val;
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_down = _resolveComponent("i-home-down");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("article", {
        class: _normalizeClass(["process-card geo-card", {
          'is-collapsed': isFold.value
        }])
      }, [_cache[2] || (_cache[2] = _createElementVNode("svg", {
        class: "geo-ana-svg-sprite",
        "aria-hidden": "true",
        focusable: "false"
      }, [_createElementVNode("defs", null, [_createElementVNode("linearGradient", {
        id: "geo-ana-grad-purple",
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, [_createElementVNode("stop", {
        "stop-color": "#8d86ff"
      }), _createElementVNode("stop", {
        offset: "1",
        "stop-color": "#5b63f4"
      })]), _createElementVNode("linearGradient", {
        id: "geo-ana-grad-green",
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, [_createElementVNode("stop", {
        "stop-color": "#31d889"
      }), _createElementVNode("stop", {
        offset: "1",
        "stop-color": "#0fb66b"
      })]), _createElementVNode("linearGradient", {
        id: "geo-ana-grad-red",
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, [_createElementVNode("stop", {
        "stop-color": "#ff6565"
      }), _createElementVNode("stop", {
        offset: "1",
        "stop-color": "#ef3038"
      })])]), _createElementVNode("symbol", {
        id: "geo-ana-icon-status-loading",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M12 4a8 8 0 1 0 8 8",
        fill: "none",
        stroke: "url(#geo-ana-grad-purple)",
        "stroke-width": "2.4",
        "stroke-linecap": "round"
      }), _createElementVNode("path", {
        d: "M20 3.8v5h-5",
        fill: "none",
        stroke: "url(#geo-ana-grad-purple)",
        "stroke-width": "2.4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-status-success",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        fill: "none",
        stroke: "url(#geo-ana-grad-green)",
        "stroke-width": "2.4"
      }), _createElementVNode("path", {
        d: "m7.7 12 3 3.1 5.8-6.2",
        fill: "none",
        stroke: "#16bd72",
        "stroke-width": "2.4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-status-error",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        fill: "none",
        stroke: "url(#geo-ana-grad-red)",
        "stroke-width": "2.4"
      }), _createElementVNode("path", {
        d: "M12 6.8v7",
        fill: "none",
        stroke: "#ef3038",
        "stroke-width": "2.8",
        "stroke-linecap": "round"
      }), _createElementVNode("circle", {
        cx: "12",
        cy: "17.5",
        r: "1.35",
        fill: "#ef3038"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-brain",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M9 4.2a3.1 3.1 0 0 0-3 3.5 3.3 3.3 0 0 0-1.8 5.5 3.2 3.2 0 0 0 3.3 5.1H9V4.2ZM15 4.2a3.1 3.1 0 0 1 3 3.5 3.3 3.3 0 0 1 1.8 5.5 3.2 3.2 0 0 1-3.3 5.1H15V4.2Z",
        fill: "url(#geo-ana-grad-purple)"
      }), _createElementVNode("path", {
        d: "M9 8.5H6.6M15 8.5h2.4M9 13H6.8M15 13h2.2M12 4.5v15",
        stroke: "#fff",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        opacity: ".68"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-shield",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M12 3.5 19 6.4v5.4c0 4.3-2.8 7.2-7 8.7-4.2-1.5-7-4.4-7-8.7V6.4l7-2.9Z",
        fill: "url(#geo-ana-grad-purple)"
      }), _createElementVNode("path", {
        d: "m8.3 12 2.4 2.5 5.1-5.6",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "2.2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-authority",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M12 3.5 19 6.4v5.4c0 4.3-2.8 7.2-7 8.7-4.2-1.5-7-4.4-7-8.7V6.4l7-2.9Z",
        fill: "url(#geo-ana-grad-purple)"
      }), _createElementVNode("path", {
        d: "m12 7.2 1.3 3 3.2.3-2.4 2.1.7 3.1-2.8-1.6-2.8 1.6.7-3.1-2.4-2.1 3.2-.3 1.3-3Z",
        fill: "#fff",
        opacity: ".92"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-user",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        cx: "9.5",
        cy: "8.1",
        r: "3.3",
        fill: "url(#geo-ana-grad-purple)"
      }), _createElementVNode("circle", {
        cx: "15.8",
        cy: "8.1",
        r: "3.1",
        fill: "#76a1ff",
        opacity: ".85"
      }), _createElementVNode("path", {
        d: "M3.7 19.5c.7-3.9 2.9-5.8 6.1-5.8 3.3 0 5.4 1.9 6.1 5.8H3.7Z",
        fill: "url(#geo-ana-grad-purple)"
      }), _createElementVNode("path", {
        d: "M12.4 19.5c.5-3 2.1-4.7 4.7-4.7 2.4 0 4.1 1.6 4.6 4.7h-9.3Z",
        fill: "#76a1ff",
        opacity: ".85"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-doc",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M6 3.8h8.2L19 8.6v11.6H6V3.8Z",
        fill: "none",
        stroke: "url(#geo-ana-grad-purple)",
        "stroke-width": "2",
        "stroke-linejoin": "round"
      }), _createElementVNode("path", {
        d: "M14 4v5h5",
        fill: "none",
        stroke: "#8176ff",
        "stroke-width": "2",
        "stroke-linejoin": "round"
      }), _createElementVNode("path", {
        d: "M9 12h6M9 15.5h6",
        stroke: "#8176ff",
        "stroke-width": "1.8",
        "stroke-linecap": "round"
      })]), _createElementVNode("symbol", {
        id: "geo-ana-icon-chart",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("rect", {
        x: "4",
        y: "4",
        width: "16",
        height: "16",
        rx: "2.6",
        fill: "url(#geo-ana-grad-purple)"
      }), _createElementVNode("path", {
        d: "m7.5 14.8 3.3-3.5 2.6 2.3 3.6-5.1",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), _createElementVNode("path", {
        d: "M7.2 18h9.6",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        opacity: ".8"
      })])], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "card-sparkles-img",
        src: _unref(sparklesIcon),
        alt: ""
      }, null, 8, _hoisted_4), _createElementVNode("span", {
        class: "card-title truncat"
      }, _toDisplayString(title)), _createElementVNode("span", _hoisted_5, _toDisplayString(titleSuffix.value), 1)]), _createElementVNode("span", {
        class: "card-subtitle"
      }, _toDisplayString(subtitle))]), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["collapse-button", {
          'is-fold': isFold.value
        }]),
        "aria-label": isFold.value ? '展开' : '收起',
        "aria-expanded": !isFold.value,
        onClick: _cache[0] || (_cache[0] = $event => toggleFold())
      }, [_createVNode(_component_el_icon, {
        class: "collapse-icon",
        color: "#4E5969"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_home_down)]),
        _: 1
      })], 10, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [!subNodes.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, "等待分析结果...")) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(subNodes.value, (node, index) => {
        return _openBlock(), _createElementBlock("section", {
          key: node.code,
          class: _normalizeClass(["analysis-row", STATUS_ROW_CLASS[node.status]])
        }, [(_openBlock(), _createElementBlock("svg", _hoisted_9, [_createElementVNode("use", {
          href: getNodeIconId(index)
        }, null, 8, _hoisted_10)])), _createElementVNode("div", _hoisted_11, [_createElementVNode("h3", {
          title: node.nodeName
        }, _toDisplayString(node.nodeName), 9, _hoisted_12), getScoreSummary(node) ? (_openBlock(), _createElementBlock("p", _hoisted_13, [_createTextVNode(_toDisplayString(getScoreSummary(node)?.label) + " ", 1), _createElementVNode("b", _hoisted_14, _toDisplayString(getScoreSummary(node)?.value), 1)])) : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(node.status === 1 ? '正在检测...' : '检测项目'), 1)), node.status === 1 && getProgress(node) !== null ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "mini-progress",
          "aria-label": `检测进度 ${getProgress(node)}%`
        }, [_createElementVNode("span", {
          style: _normalizeStyle({
            width: `${getProgress(node)}%`
          })
        }, null, 4)], 8, _hoisted_16)) : node.status === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", {
          class: "indeterminate"
        }, null, -1)]))])) : _createCommentVNode("", true), node.status === 2 && node.data?.error ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("span", {
          title: node.data.error
        }, "失败原因：" + _toDisplayString(node.data.error), 9, _hoisted_19), _createElementVNode("button", {
          type: "button",
          onClick: $event => handleRetry(node)
        }, "重试", 8, _hoisted_20)])) : _createCommentVNode("", true)]), _createElementVNode("span", {
          class: _normalizeClass(["status-pill", STATUS_PILL[node.status]?.class])
        }, [STATUS_PILL[node.status]?.iconId ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [_createElementVNode("use", {
          href: STATUS_PILL[node.status].iconId
        }, null, 8, _hoisted_22)])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(STATUS_PILL[node.status]?.text || '待开始'), 1)], 2)], 2);
      }), 128))])], 2);
    };
  }
});